/**
 * webcast helper class for common kwebcast functions
 */
import { KmsTypeSchedulingTimeInterval } from "@kaltura/mediaspace-shared-types";

export enum WebcastStatus {
    noScheduling = "",
    live = "live",
    past = "past",
    future = "future",
}

export class WebcastHelper {
    /**
     * get current entry status per scheduling
     */
    static getLiveStatus = (schedulingData?: KmsTypeSchedulingTimeInterval) => {
        if (!schedulingData) {
            return WebcastStatus.noScheduling;
        }

        const { start, end } = schedulingData;
        const now = Date.now() / 1000;
        if (end.timestamp < now) {
            return WebcastStatus.past;
        }
        if (start.timestamp > now) {
            return WebcastStatus.future;
        }
        return WebcastStatus.live;
    };

    /**
     * Add join buffer before the event start time
     */
    static applyJoinBuffer = (
        schedulingData: KmsTypeSchedulingTimeInterval,
        joinBufferInMinutes: number
    ): KmsTypeSchedulingTimeInterval => ({
        ...schedulingData,
        start: {
            ...schedulingData.start,
            timestamp: schedulingData.start.timestamp - joinBufferInMinutes * 60,
        },
    });
}
